import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";

import TicketItemHeader from "./TicketItemHeader";
import TicketDetails from "./TicketDetails";

const TicketItems = () => {
  const navigate = useNavigate();

  const handleRedirectTickets = () => {
    navigate("/tickets");
  };

  return (
    <Accordion
      sx={{
        borderRadius: "12px 12px 0 0",
        "&::before": {
          display: "none!important",
        },
        marginBottom: "15px",
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          display: "flex",
          flexDirection: "row-reverse",
          background: "#F7F7F7",
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          sx={{
            flexBasis: "100%",
          }}
        >
          <Typography>Unable to display video</Typography>
          <Typography>Created on: 5/29/2023, 21:59:42</Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box display="flex" justifyContent="space-between">
          <Box>
            <TicketItemHeader>Correlate</TicketItemHeader>
            <TicketDetails>
              The picture is not displaying properly
            </TicketDetails>
          </Box>

          <Box>
            <TicketItemHeader>Location</TicketItemHeader>
            <TicketDetails>Austin</TicketDetails>
          </Box>

          <Box>
            <TicketItemHeader>Platform</TicketItemHeader>
            <TicketDetails>Android N_MR1</TicketDetails>
          </Box>

          <Box>
            <TicketItemHeader>Video Quality</TicketItemHeader>
            <TicketDetails>Alert</TicketDetails>
          </Box>

          <Box>
            <TicketItemHeader>Sentiment</TicketItemHeader>
            <TicketDetails>Negative</TicketDetails>
          </Box>

          <Box>
            <TicketItemHeader>Number affected</TicketItemHeader>
            <TicketDetails>1.2 Million</TicketDetails>
          </Box>

          <Box>
            <TicketItemHeader>Source</TicketItemHeader>
            <TicketDetails>Twitter Storm</TicketDetails>
          </Box>
        </Box>

        <Box display="flex" sx={{ marginTop: "30px" }}>
          <Box mr="30px">
            <TicketItemHeader>Number of users</TicketItemHeader>
            <TicketDetails>
              <Avatar
                sx={{
                  background: "#2858D3",
                  color: "#FFF",
                  fontSize: "12px",
                }}
              >
                +36k
              </Avatar>
            </TicketDetails>
          </Box>

          <Box>
            <TicketItemHeader>Attachment</TicketItemHeader>
            <TicketDetails>Twitter Storm</TicketDetails>
          </Box>
        </Box>

        <Grid
          item
          container
          sx={{
            marginTop: "30px",
          }}
          justifyContent="end"
        >
          <Button
            variant="text"
            sx={{
              fontSize: 12,
              color: "#2858D3",
              fontWeight: 700,
              marginLeft: 0,
              padding: 0,
            }}
            onClick={handleRedirectTickets}
          >
            REPLY ALL
          </Button>
          <Divider
            orientation="vertical"
            sx={{
              height: "15px",
              marginLeft: "12px",
            }}
          />
          <Button
            variant="text"
            sx={{
              fontSize: 12,
              color: "#2858D3",
              fontWeight: 700,
              marginLeft: "12px",
              padding: 0,
            }}
          >
            VIEW DETAILS
          </Button>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default TicketItems;
